// eslint-disable-next-line no-unused-vars
import React from 'react';
import './index.scss';
const nop = f => f;
const DefaultImg = '//s.qunarzz.com/package/touch/apphome/s/bg.jpg';
const MoreTitle = (props) => {
    const {text = '查看更多', ClickMore = nop, type = 'bg', bgUrl = DefaultImg, customBg = ''} = props;
    return (
        <div onClick={ClickMore} className={`moreTitle`}>
            <div className={`more-bg ${customBg}`} style={{
                backgroundImage: `url(${bgUrl})`
            }}></div>
            <div className={`${type === 'btn' ? 'more' : 'text'}`}>{text}</div>
        </div>
    );
};

export default MoreTitle;